import axios from 'axios';


// const HOST = "http://localhost:7910"
// const HOST = "neural-net-backend" //### DEPLOY: DOCKER
const HOST = "https://neural-net.se.jku.at/api"

export class Database {


    requestTrainingData(frame) {
        axios.get(HOST + "/neural-net/trainingData/",
            { params: {} })
            .then(res => { frame.receiveTrainingData(res.data.value) })
            .catch(thrown => { frame.receiveDatabaseError(thrown.message) })
    }


    requestTestData(frame) {
        axios.get(HOST + "/neural-net/testData/",
            { params: {} })
            .then(res => { frame.receiveTestData(res.data.value) })
            .catch(thrown => { frame.receiveDatabaseError(thrown.message) })
    }


    insertColor(hexColor, label, userID, training, frame) {
        axios.post(HOST + "/neural-net/setcolor/",
            { hexColor: hexColor, label: label, userID: userID, training: training })
            .then(() => { frame.receiveInsertOk() })
            .catch(thrown => { frame.receiveDatabaseError(thrown.message) })
    }


    deleteColor(colorID, frame) {
        axios.delete(HOST + "/neural-net/deletecolor/",
            { params: { colorID: colorID } })
            .then(() => { frame.receiveDeleteOk() })
            .catch(thrown => { frame.receiveDatabaseError(thrown.message) })
    }

}


